import { queryOptions, useQuery } from '@tanstack/react-query';

import { inventoryApi } from '../api/inventory-api';

import { inventoryKeys } from './inventory-keys';

/** Shared by the variant inventory route loader and the page. */
export function inventoryItemQueryOptions(storeId: string, variantId: string) {
  return queryOptions({
    queryKey: inventoryKeys.item(storeId, variantId),
    queryFn: () => inventoryApi.item(storeId, variantId),
  });
}

export function useInventoryItem(storeId: string, variantId: string, enabled = true) {
  return useQuery({ ...inventoryItemQueryOptions(storeId, variantId), enabled });
}
